import React from 'react'

function MessageParser({ children, actions }) {

    const parse = (message) => {
        const step = actions.userData?.step;
        

        switch(step){
            case "askName": actions.handleNameInput(message);
                return;
            case "askEmail": actions.handleEmailInput(message);
                return;
            case "askContact": actions.handleContactInput(message);
                return;
            case "askCompany": actions.handleCompanyNameInput(message);
                return;
            case "askCompanyMail": actions.completeDetails(message);
                return;
        }

        message = message.toLowerCase();
        const greetings = ["hello", "hi", "hii", "hy", "good morning", "good evening", "morning", "evening", "night"];
        const thanks = ["thanks", "thank you", "thx", "thankyou"];
        const help = ["help", "assist", "support", "i need help", "can you help"];
        const farewells = ["bye", "goodbye", "see you", "see ya", "farewell", "take care"];
        
        if(greetings.some(greet => message.includes(greet))){
            actions.handleHello();
        }
        else if(thanks.some(word => message.includes(word))){
            actions.handleThanks();
        }else if(help.some(word => message.includes(word))){
            actions.handleHelp();
        }else if(farewells.some(word => message.includes(word))){
            actions.handleBye();
        }else{
            actions.handleInvalidQuery();
        }


    }

  return (
    <div>
      {
        React.Children.map(children, (child) => {
            return React.cloneElement(child, {
                parse: parse,
                actions: actions
            })
        })
      }
    </div>
  )
}

export default MessageParser
